"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/chips/index.ts
var chips_exports = {};
__export(chips_exports, {
  Chips: () => Chips_default,
  default: () => Chips_default
});
module.exports = __toCommonJS(chips_exports);
var import_index = require("./index.css");

// src/chips/Chips.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_uniq = __toESM(require("lodash/uniq"));
var import_react2 = require("react");

// src/chips/_Chip.tsx
var import_classnames = __toESM(require("classnames"));
var import_react = require("react");

// src/chips/chip.module.scss
var chip_module_default = {
  "heading-xxl": "chip-module__heading-xxl___S4YIy",
  "heading-xl": "chip-module__heading-xl___YZRLc",
  "heading-lg": "chip-module__heading-lg___Fx19c",
  "heading-md": "chip-module__heading-md___1X-xx",
  "heading-sm": "chip-module__heading-sm___H86PJ",
  "heading-xs": "chip-module__heading-xs___tYy29",
  "body-one": "chip-module__body-one___pZP8h",
  "body-two": "chip-module__body-two___5kHhf",
  "body-three": "chip-module__body-three___n7fHw",
  "body-four": "chip-module__body-four___AVLBz",
  "overline-one": "chip-module__overline-one___VtqKS",
  "overline-two": "chip-module__overline-two___kmuCH",
  "overline-three": "chip-module__overline-three___NFyJY",
  "strong": "chip-module__strong___dHCEa",
  "extra-strong": "chip-module__extra-strong___7qhXn",
  "em": "chip-module__em___u3m-1",
  "figcaption": "chip-module__figcaption___HYvAm",
  "chips": "chip-module__chips___0JGq7",
  "chipsContainer": "chip-module__chipsContainer___jtRGZ",
  "chip": "chip-module__chip___HKQlG",
  "chips-black": "chip-module__chips-black___Xq6mp",
  "chips-gray": "chip-module__chips-gray___eZjpH",
  "chips-l": "chip-module__chips-l___5KTqf",
  "groupLabel": "chip-module__groupLabel___8bgMu",
  "chip-thick": "chip-module__chip-thick___W-9l0",
  "chip-thin": "chip-module__chip-thin___-slju",
  "chips-m": "chip-module__chips-m___N1FgP",
  "chips-s": "chip-module__chips-s___PIiem",
  "chips-xs": "chip-module__chips-xs___upKD7"
};

// src/chips/_Chip.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Chip = ({
  label,
  name,
  value,
  checked,
  required,
  requiredMessageText,
  textThickness,
  disabled,
  onCheckedChange,
  ...HTMLAttributes2
}) => {
  const inputRef = (0, import_react.useRef)(null);
  (0, import_react.useEffect)(() => {
    const input = inputRef.current;
    if (input) {
      input.setCustomValidity("");
    }
  }, [inputRef, onCheckedChange]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
    "label",
    {
      className: (0, import_classnames.default)(
        chip_module_default.chip,
        chip_module_default[`chip-${textThickness}`]
      ),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "input",
          {
            ref: inputRef,
            type: "checkbox",
            name,
            value,
            checked,
            required,
            disabled,
            onChange: (e) => {
              onCheckedChange(e.target.checked);
              e.target.setCustomValidity("");
            },
            onInvalid: (e) => {
              e.target.setCustomValidity(
                requiredMessageText || "Please choose at least one option"
              );
            },
            ...HTMLAttributes2
          }
        ),
        label
      ]
    }
  ) });
};
var Chip_default = (0, import_react.memo)(Chip);

// src/chips/Chips.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var Chips = ({
  label,
  name,
  required,
  requiredMessageText,
  disabled,
  options,
  values,
  setValues,
  textThickness = "thin",
  color = "black",
  size = "m",
  className
}) => {
  const inputName = `${name}[]`;
  (0, import_react2.useEffect)(() => {
    if (required && !requiredMessageText) {
      console.warn(
        'For usages of the Chips component where the "required" prop is set to true, a localized error message to display when no option is selected is needed.'
      );
    }
  }, [required, requiredMessageText]);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: (0, import_classnames2.default)(
        chip_module_default.chips,
        chip_module_default[`chips-${color}`],
        chip_module_default[`chips-${size}`],
        className
      ),
      "data-testid": `chips-${name}`,
      children: /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("fieldset", { children: [
        label && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("label", { className: chip_module_default.groupLabel, children: label }),
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: chip_module_default.chipsContainer, children: options.map((option) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          Chip_default,
          {
            label: option.label,
            name: inputName,
            value: option.value,
            textThickness,
            checked: values.includes(option.value),
            required: required ? values.length === 0 : false,
            requiredMessageText,
            disabled,
            onCheckedChange: (checked) => {
              if (checked) {
                setValues((0, import_uniq.default)([...values, option.value]));
              } else {
                setValues(values.filter((v) => v !== option.value));
              }
            }
          },
          option.value
        )) })
      ] })
    }
  );
};
var Chips_default = Chips;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Chips
});
//# sourceMappingURL=index.js.map